import { authReducer } from 'shared/state/auth';

export const globalReducer = ({ auth }, action) => {
    // middleware goes here, i.e calling analytics service, etc.
    return {
        auth: authReducer(auth, action)
    };
};
